<template>
  <dtunes-modal v-if="!success">
    <template v-slot:button> 
      <v-icon>mdi-plus</v-icon>
      Create new team 
    </template>
    <template v-slot:content>
      <v-card class="pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center"><b>CREATE NEW TEAM</b></p>
        </v-card-title>
        <v-card-text>
          <v-text-field color="orange" v-model="name" label="Name" outlined ></v-text-field>
          <br>
          <!-- <v-text-field color="orange" hint="Optional" label="Description" outlined ></v-text-field>
          <br> -->
          <v-select
          v-model="value"
          :items="Permissions"
          item-text="name"
          item-value="key"
          :rules="formRules"
          :menu-props="{ maxHeight: '200' }"
          color="orange"
          label="Select Permissions"
          outlined
          multiple
          >
            <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item.name }}</span>
        </v-chip>
        <span
          v-if="index === 1"
          class="grey--text text-caption"
        >
          (+{{ value.length - 1 }} others)
        </span>
      </template>
          </v-select>
          <br>
          <default-button :loading="loading" :disabled="!isComplete" @click="createTeam()">Create team</default-button>
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from '@/components/Buttons/default-button.vue';
import { PermissionService, TeamService } from "@/services";
import app from '@/main';

export default {
    data:() => ({
        loading: false,
        value:[],
        rules: [],
        name:'',
       // description:'',
        Permissions:[],
        success: false, // Flag to indicate if team creation was successful
        formRules:[
          (v) => !!v || "This field is required",
        ]
    }),
    computed:{
      isComplete() {
        return this.name && this.value;
    },
    },
    methods:{
      async getPermissions(){
        const data = await PermissionService.getPermissions();
        this.Permissions = data
      },
      async createTeam(){
        this.loading = true;
        const data = await TeamService.createTeam({
          name: this.name,
          permissions : this.value
        });
        console.log(data);
        if(data) {
          this.success = true;
          this.loading = false;
          app.$store.dispatch('toast', {
          message: 'Team created successfully',
          variant: 'success'
        })
          setTimeout(()=>{ this.success = false;},100);
          this.$emit("team-created");
        }
        

      }
    },
    mounted(){
      this.getPermissions();
    },
  components: {
    DtunesModal,
    DefaultButton
  },
};
</script>